import { createServerTypeInstances, ServerTypeUI } from "./servertypeUI";

class ServerType {
  public constructor(private ui: ServerTypeUI) {
    this.ui.onChange(this.handleOnChange.bind(this));
  }

  public handleOnChange(val: string) {
    if (val === 'official') {
      this.ui.toggleMapCycleInofficial(false);
      this.ui.toggleMapCycleOfficial(true);
    } else {
      this.ui.toggleMapCycleInofficial(true);
      this.ui.toggleMapCycleOfficial(false);
    }
  }
}

export function initServerType() {
  return createServerTypeInstances().map((ui: ServerTypeUI) => {
    return new ServerType(ui);
  });
}
